import { NavLink } from "react-router-dom";

export default function Navigation() {
  const navItems = [
    { path: "/", name: "मुखपृष्ठ", active: true },
    { path: "/goals", name: "ध्येय", active: true },
    { path: "/founders", name: "संस्थापक", active: true },
    { path: "/vishwasthamandals", name: "विश्वस्त", active: true },
    { path: "/vidyamanmandals", name: "कार्यकारी मंडळ", active: true },
    { path: "/upakram", name: "उपक्रम", active: true },
    { path: "/halls", name: "हॉल", active: true },
    { path: "/computers", name: "संगणक संस्था", active: true },
    { path: "/photos", name: "फोटो गॅलरी", active: true },
    { path: "/ahaval", name: "अहवाल", active: true },
    {
      path: "/contactus",
      name: "संपर्क",
      active: true,
    },
  ];
  return (
    <div className="div-topmenu">
      <div className="div-menu1">
        <ul>
          {navItems.map(
            (item, index) =>
              item.active && (
                <li key={index + 1}>
                  <NavLink to={item.path}>{item.name}</NavLink>
                </li>
              )
          )}
        </ul>
      </div>
    </div>
  );
}
